<template>
    <div class="row pl-3 pr-3 mb-3">
        <div class="col-12">
            <div class="row border rounded summary--section">
                <template v-if="!$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED">
                    <div
                        class="col-12 col-md-5 border-right border-xs-right-none pt-2 pb-2"
                        :class="{
                            'd-flex align-items-center justify-content-center': (collectionEndDate == null && collectionStartDate != null) || expiryDate && expiryDate != ''
                        }
                    ">
                        <div class="text-center" v-if="expiryDate && expiryDate != ''">
                            <h6 class="font-weight-bold text-uppercase text--gray">
                                Expiry Date
                            </h6>
                            <div>{{ expiryDate }}</div>
                        </div>
                        <template v-else>
                            <div v-if="collectionEndDate != null" class="d-inline-block d-md-flex justify-content-center">
                                <strong v-html="collectionStartDate.getDate()"></strong>&nbsp;<span v-html="collectionStartDate.formatMonYyyy()"></span>
                            </div>
                            <div v-if="collectionEndDate != null"  class="d-inline-block d-block text-center px-2">
                                to
                            </div>
                            <div v-if="collectionEndDate == null && collectionStartDate != null"  class="d-inline-block d-block text-center">
                                <strong v-html="collectionStartDate.getDate()"></strong>
                                &nbsp;<span v-html="collectionStartDate.formatMonYyyy()"></span>
                            </div>
                            <div v-if="collectionEndDate != null"  class="d-inline-block d-md-flex justify-content-center">
                                <strong v-html="collectionEndDate.getDate()"></strong>
                                &nbsp;<span v-html="collectionEndDate.formatMonYyyy()"></span>
                            </div>
                            <div v-if="collectionStartDate == null && collectionEndDate == null" class="d-inline-block d-md-flex justify-content-center align-items-center w-100 h-100" v-html="TEXTS.render(`BOOKING_SUMMARY_NO_DATE_SELECTED`)"></div>
                        </template>
                    </div>
                    <div class="col-12 col-md-7 pt-2 pb-2">
                        <div class="d-flex">
                            <div class="col-1 pt-1 pl-md-1 pr-3 pr-md-0">
                                <i aria-hidden="true" class="icon icon-pin float-right"></i>
                            </div>
                            <div class="col-11 pl-md-1 skiptranslate">
                                <span class="font-weight-bold text-capitalize">{{ loadActiveAddress.toLowerCase() }}</span>
                            </div>
                        </div>
                        <div class="d-flex"> 
                            <div class="col-1 pl-md-1 pr-3 pr-md-0">
                            </div>
                            <div class="col-11 pl-md-1">
                            {{ bookingState && bookingState.selectedServiceGroup && bookingState.selectedServiceGroup.group_name}}
                            </div>
                        </div>
                    </div>
                </template>
                
                <div
                    class="col-12 col-md-4 pt-4 pb-4 d-flex align-items-center"
                    v-if="$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED && classes">
                    <div class="text-center w-100" v-html="bookingDateNow"></div>
                </div>
                <div
                    class="col-12 pt-4 pb-4 d-flex align-items-center"
                    v-if="$store.getters.GET_IS_MULTIPLE_SERVICE_BOOKING_ENABLED"
                    :class="{ 'col-md-12': !classes, 'col-md-8 border-left': classes }">
                    <div class="d-flex">
                        <div class="col-1 d-flex align-items-center">
                            <i aria-hidden="true" class="icon icon-pin address-map-marker"></i>
                        </div>
                        <div class="col-11">
                            <span class="text-capitalize skiptranslate">{{ loadActiveAddress.toLowerCase() }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import DateFormattable from '../../../../common/utils/DateFormattable'
    import Texts from '../../../../common/utils/Texts'
    import DateNoTz from '../../../../common/utils/DateNoTz';
    import ServerDateMixin from '../../../../common/mixins/ServerDateMixin'

    export default {
        mixins : [ServerDateMixin],
        props: {
            classes: Boolean,
            expiryDate: String
        },
        computed: {
            bookingDateNow() {
                const d = new DateNoTz(this.getServerDate());
                return  d.getDateWithZero() + ' ' + d.getMonthDescShort() + ' ' + d.getFullYear();
            },
            TEXTS : ()=> Texts,
            bookingState : function(){
                return this.$store.getters.GET_BOOKING_STATE;
            },
            collectionStartDate: function(){
                var collectionData = this.$store.getters.GET_BOOKING_STATE.collectionData;
                if(!collectionData || !collectionData.periodType || !collectionData.selectedPeriod ){
                    return null;
                }
                else if(collectionData && (collectionData.periodType == "daily" || collectionData.periodType == "predefined_day" || collectionData.periodType == "daily_with_default")){
                    return new DateFormattable(collectionData.selectedPeriod);
                }
                else if(collectionData.periodType == "weekly" || collectionData.periodType == "predefined_week"){
                    return new DateFormattable(collectionData.selectedPeriod.start);
                }
                return null;
            },
            startDate() {
                return this.collectionStartDate.getDate();
            },
            startDateYear() {
                return this.collectionStartDate.formatMonYyyy();
            },
            collectionEndDate: function(){
                var collectionData = this.$store.getters.GET_BOOKING_STATE.collectionData;
                if(!collectionData || !collectionData.periodType || !collectionData.selectedPeriod){
                    return null;
                }
                else if(collectionData && (collectionData.periodType == "daily" || collectionData.periodType == "predefined_day" || collectionData.periodType == "daily_with_default")){
                    return null;
                }
                else if(collectionData.periodType == "weekly" || collectionData.periodType == "predefined_week"){
                    return new DateFormattable(collectionData.selectedPeriod.end);
                }
                return null;
            },
            endDate() {
                return this.collectionStartDate.getDate();
            },
            endDateYear() {
                return this.collectionStartDate.formatMonYyyy();
            },
            loadActiveAddress: function() {
                return this.bookingState.activeAddress ? this.bookingState.activeAddress.displayName : ""
            }
        }
    }
</script>